/**
 * Ortalanmış ve minimum süreli notify fonksiyonu
 * @param {string} message
 * @param {'info'|'success'|'warning'|'error'} type
 * @param {number} [duration] - ms cinsinden, hata ise 4000, diğerleri için 3000
 */
export default function notifyCenter(message, type = 'info', duration) {
    const displayTime = duration || (type === 'error' ? 4000 : 3000);
    let host = document.getElementById('bootstrap-notify-host');
    if (!host) {
        host = document.createElement('div');
        host.id = 'bootstrap-notify-host';
        host.style.position = 'fixed';
        host.style.left = '50%';
        host.style.top = '50%';
        host.style.zIndex = '2000';
        host.style.transform = 'translate(-50%, -50%)';
        host.style.minWidth = 'min(420px, calc(100vw - 24px))';
        host.style.maxWidth = 'min(480px, calc(100vw - 24px))';
        host.style.display = 'flex';
        host.style.flexDirection = 'column';
        host.style.gap = '10px';
        host.style.alignItems = 'center';
        document.body.appendChild(host);
    }
    const alert = document.createElement('div');
    const variant = type === 'error' ? 'danger' : type === 'warning' ? 'warning' : type === 'success' ? 'success' : 'info';
    alert.className = `alert alert-${variant} shadow`;
    alert.setAttribute('role', 'alert');
    alert.style.fontSize = '1.08rem';
    alert.style.fontWeight = '700';
    alert.style.color = '#111827';
    alert.style.borderWidth = '2px';
    alert.style.borderRadius = '10px';
    alert.style.lineHeight = '1.4';
    alert.style.minHeight = '52px';
    alert.style.padding = '12px 18px';
    alert.style.boxShadow = '0 12px 28px rgba(15, 23, 42, 0.22)';
    alert.style.textAlign = 'center';
    alert.style.wordBreak = 'break-word';
    alert.style.width = '100%';
    alert.style.maxWidth = '440px';
    alert.textContent = String(message ?? '');
    host.appendChild(alert);
    window.setTimeout(() => alert.remove(), displayTime);
}
